import { render, staticRenderFns } from "./Scatter.vue?vue&type=template&id=51650145"
import script from "./Scatter.vue?vue&type=script&lang=js"
export * from "./Scatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports